import { Button } from '@/components/ui/button';
import React from 'react';
import { useAuthActions } from '@/utils/auth';
import EmptyLayout from './EmptyLayout';

const EmptyLayoutWithLogoutFooter: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const { signOut } = useAuthActions();
  return (
    <EmptyLayout>
      {children}
      <div className="flex justify-center items-center w-full p-12">
        <Button
          variant="destructive"
          onClick={() => {
            signOut();
          }}
        >
          Salir
        </Button>
      </div>
    </EmptyLayout>
  );
};

export default EmptyLayoutWithLogoutFooter;
